import { type CommonAction, success } from "@iflyrpa/share";
import type { ActiomCommonParams } from "../../types";
import { Http } from "../../utils/http";

export interface GetShipinhaoConfigParams extends ActiomCommonParams {}

export interface ConfigData {
    accountInfo: {
        nickname: string;
        avatar: string;
        finder_username: string;
    };
    publishQuota: {
        daily_limit: number;
        used_today: number;
        remaining: number;
    };
}

export type PublishAction = CommonAction<GetShipinhaoConfigParams, ConfigData>;

export const getShipinhaoConfig: PublishAction = async (_task, params) => {
    const http = new Http({
        headers: {
            cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
            referer: "https://channels.weixin.qq.com/platform/post/finderNewLifeCreate",
            origin: "https://channels.weixin.qq.com",
        },
    });

    // 生成 UUID 和短 ID
    const WEIXIN_VIDEO_AID = "e48c8258-e782-483a-bcb1-be248537988f";
    const generateRid = () => {
        const s = () => Math.random().toString(36).substring(2, 10);
        return `${s()}-${s()}`;
    };

    const res = await http.api<any>({
        method: "get",
        url: "https://channels.weixin.qq.com/micro/content/cgi-bin/mmfinderassistant-bin/account/get_account_info",
        params: {
            _aid: WEIXIN_VIDEO_AID,
            _rid: generateRid(),
            _pageUrl: "https://channels.weixin.qq.com/micro/content/post/finderNewLifeCreate",
        },
    });

    const configData: ConfigData = {
        accountInfo: res.account_info || {},
        publishQuota: res.publish_quota || {},
    };

    return success(
        configData,
        res.base_resp?.ret === 0 ? "微信视频号配置信息获取成功！" : "微信视频号配置信息获取失败！",
    );
};
